import React from 'react'
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { errorMsg } from '../../../config/constant'
import {
  setCurrentMovie,
  setPreviousMovie,
  nextMovie
} from '../../../action/VodAction';
import { popupOpenClose, setVideoPlayer } from '../../../action/action'
import MovieCard from './movieCard';
import { movieCardAnimation } from '../../../JS/movieCardAnimation'
import $ from 'jquery'
import { VODMovieInfoColor } from '../../../JS/setColors'

class moiveInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      swipeTo: false,
      firstID: "previousTile",
      secondID: "currentTile",
      thirdID: "nextTile",
      stateCurrentActivity: this.props.currentActivity,
      currentCard: 1,
      firstMovie: true,
      lastMovie: true
    }
  }


  static getDerivedStateFromProps(props, state) {
    // console.log("props.movieInfo", props.movieInfo);
  }

  handleTouchSt = (event) => {
    //console.log("touchEventStart", event.touches);
    if (event.touches) {
      return event.touches[0].clientX;
    }
    return null;
  }

  //get touch move coordinates
  handleTouchMove = (event) => {
    //console.log("touchEventMove", event.touches);
    if (event.touches) {
      return event.touches;
    }
    return null;
  }

  handleTouchEnd = (moveTouch, startTouch, l) => {
    //console.log("method get called", moveTouch, startTouch);
    let startX, startY, endX, endY, xDiff, yDiff;
    if (!startTouch || !moveTouch) {
      return;
    }
    endX = moveTouch[0].clientX;
    endY = moveTouch[0].clientY;
    xDiff = startTouch - endX;
    //console.log("xDiff", xDiff)
    if (xDiff > 14) {
      console.log("left swipe");
      this.swipeGestureWorking("left");
    } else if (xDiff === 0) {
      console.log("its click not swipe");
    } else if (xDiff < -14) {
      console.log("right swipe");
      this.swipeGestureWorking("right");
    }
  }

  wipeEventListner = () => {
    let starTouch, moveTouch, lastTouch;
    let startEventMethod = (event) => {
      starTouch = this.handleTouchSt(event);
     // console.log("starTouch");
    }
    let moveEventListner = (event) => {
      moveTouch = this.handleTouchMove(event);
      //console.log("moveTouch", this.handleTouchMove(event));
      lastTouch = event.touches[0].clientX;
    }
    let endEventListner = () => {
      this.handleTouchEnd(moveTouch, starTouch, lastTouch);
      // console.log("moveTouch,startTouch", moveTouch, starTouch);
      starTouch = 0;
      moveTouch = 0;
    }
    if (this.props.movieInfo) {
      document.querySelector("#currentTile").addEventListener(
        'touchstart', startEventMethod);
      document.querySelector("#currentTile").addEventListener(
        'touchmove', moveEventListner);
      document.querySelector("#currentTile").addEventListener(
        'touchend', endEventListner);
    }
    document.querySelector("#previousTile").addEventListener(
      'touchstart', startEventMethod);
    document.querySelector("#previousTile").addEventListener(
      'touchmove', moveEventListner);
    document.querySelector("#previousTile").addEventListener(
      'touchend', endEventListner);

    document.querySelector("#nextTile").addEventListener(
      'touchstart', startEventMethod);
    document.querySelector("#nextTile").addEventListener(
      'touchmove', moveEventListner);
    document.querySelector("#nextTile").addEventListener(
      'touchend', endEventListner);
  }

  componentDidMount() {
    VODMovieInfoColor(this.props.menuColor);
    this.wipeEventListner();
  }
  backButton = () => {
    this.props.setCurrentMovie("");
  }

  showMovieInfo = (current, currentIndex) => {
    //console.log("In Movie");
    let previous = null, previousFlag = false, nextFlag = true;
    this.props.setCurrentMovie(current);
    //console.log("index", this.props.category);
    if (this.props.currentMovieList.length > 0) {
      this.props.currentMovieList.map((iterator, index) => {
        if (nextFlag && currentIndex < index) {
          nextFlag = false
          console.log("next", iterator.videoTitle);
          this.props.nextMovie(iterator);
        }
        if (currentIndex > index) {
          previousFlag = true;
          previous = iterator;
          console.log("previous", previous.videoTitle);
        }
      })
      if (previousFlag) {
        this.props.setPreviousMovie(previous);
      } else {
        this.props.setPreviousMovie(null);
      }
      if (nextFlag) {
        this.props.nextMovie(null);
      }
    }
  }

  firstLeftSwipe = () => {
    this.setState({
      firstID: "nextTile",
      secondID: "previousTile",
      thirdID: "currentTile",
      currentCard: (this.state.currentCard + 1) % 3,
      swipeTo: "left",
    })
  }

  secondLeftSwipe = () => {
    this.setState({
      firstID: "currentTile",
      secondID: "nextTile",
      thirdID: "previousTile",
      currentCard: (this.state.currentCard + 1) % 3,
      swipeTo: "left",
    })
  }

  thirdLeftSwipe = () => {
    this.setState({
      firstID: "previousTile",
      secondID: "currentTile",
      thirdID: "nextTile",
      currentCard: (this.state.currentCard + 1) % 3,
      swipeTo: "left",
    })
  }

  firstRightSwipe = () => {
    this.setState({
      firstID: "currentTile",
      secondID: "nextTile",
      thirdID: "previousTile",
      currentCard: this.state.currentCard !== 0 ? this.state.currentCard - 1 : 2,
      swipeTo: "right",
    })
  }

  secondRightSwipe = () => {
    this.setState({
      firstID: "nextTile",
      secondID: "previousTile",
      thirdID: "currentTile",
      currentCard: this.state.currentCard !== 0 ? this.state.currentCard - 1 : 2,
      swipeTo: "right",
    })
  }

  thirdRightSwipe = () => {
    this.setState({
      firstID: "previousTile",
      secondID: "currentTile",
      thirdID: "nextTile",
      currentCard: this.state.currentCard !== 0 ? this.state.currentCard - 1 : 2,
      swipeTo: "right",
    })
  }

  SetupdateMovie = (MovieInfo, swipeType) => {
    //console.log("MovieInfo=", MovieInfo)
    if (swipeType === "left") {
      if (this.state.currentCard === 2) {
        this.props.setPreviousMovie(MovieInfo);
      } else if (this.state.currentCard === 1) {
        this.props.nextMovie(MovieInfo);
      } else if (this.state.currentCard === 0) {
        this.props.setCurrentMovie(MovieInfo);
      }
    } else if (swipeType === "right") {
      if (this.state.currentCard === 2) {
        this.props.setCurrentMovie(MovieInfo);
      } else if (this.state.currentCard === 1) {
        this.props.setPreviousMovie(MovieInfo);
      } else if (this.state.currentCard === 0) {
        this.props.nextMovie(MovieInfo);
      }
    }

  }
  updatedMovieCard = (currentMovie, currrentMovieIndex, swipeType) => {
    //   console.log("current Movie.", currentMovie.videoTitle, currrentMovieIndex)
    let previous = null, previousFlag = false, nextFlag = true;
    if (swipeType === "left") {
      console.log(" this.props.movieList", this.props.currentMovieList.length)
      this.props.currentMovieList.map((iterator, index) => {
        if (nextFlag && currrentMovieIndex < index) {
          nextFlag = false
          // console.log("next", iterator.videoTitle);
          this.SetupdateMovie(iterator, swipeType);
        }
      })
      if (nextFlag) {
        this.SetupdateMovie(null, swipeType);
      }
    } else if (swipeType === "right") {
      this.props.currentMovieList.map((iterator, index) => {
        if (currrentMovieIndex > index) {
          previousFlag = true;
          previous = iterator;
          //console.log("previous", previous.videoTitle);
        }
      })
      if (previousFlag) {
        this.SetupdateMovie(previous, swipeType);
      } else {
        this.SetupdateMovie(null, swipeType);
      }
    }
  }

  swipeGestureWorking = (swipeGesture) => {
    let currentMovieCard;
    //console.log("time out current card=", this.state.currentCard);
    if (this.state.currentCard === 2) {
      currentMovieCard = this.props.nextMovieInfo
    } else if (this.state.currentCard === 1) {
      currentMovieCard = this.props.movieInfo
    } else if (this.state.currentCard === 0) {
      currentMovieCard = this.props.preMovieInfo
    }
    let currentMovieIndex = this.props.currentMovieList.indexOf(currentMovieCard);
    console.log("currentMovieIndex", currentMovieIndex);
    if (swipeGesture === "left" && this.props.currentMovieList.length >= currentMovieIndex + 2) {
      $(`#currentTile`).siblings().removeClass('prev active next');
      $(`#currentTile`).removeClass('active');
      $(`#nextTile`).addClass('active');
      $(`#currentTile`).addClass('prev');
      $(`#previousTile`).addClass('next');
      //console.log("Left swipe", `#${this.state.secondID}`);
      if (this.state.currentCard % 3 === 1) {
        this.firstLeftSwipe();
      } else if (this.state.currentCard % 3 === 2) {
        this.secondLeftSwipe();
      } else if (this.state.currentCard % 3 === 0) {
        this.thirdLeftSwipe();
      }
      setTimeout(
        () => {
          let currentMovie;
          //console.log("time out current card=", this.state.currentCard);
          if (this.state.currentCard === 2) {
            currentMovie = this.props.nextMovieInfo
          } else if (this.state.currentCard === 1) {
            currentMovie = this.props.movieInfo
          } else if (this.state.currentCard === 0) {
            currentMovie = this.props.preMovieInfo
          }
          this.updatedMovieCard(
            currentMovie,
            this.props.currentMovieList.indexOf(currentMovie),
            "left");
        }
        , 200)
    }
    if (swipeGesture === "right" && 0 <= currentMovieIndex - 1) {
      // console.log("R"); 
      $(`#currentTile`).siblings().removeClass('prev active next');
      $(`#currentTile`).removeClass('active');
      $(`#previousTile`).addClass('active');
      $(`#nextTile`).addClass('prev');
      $(`#currentTile`).addClass('next');
      if (this.state.currentCard % 3 === 1) {
        this.firstRightSwipe();
      } else if (this.state.currentCard % 3 === 0) {
        this.secondRightSwipe();
      } else if (this.state.currentCard % 3 === 2) {
        this.thirdRightSwipe();
      }
      setTimeout(
        () => {
          let currentMovie;
          //console.log("time out current card=", this.state.currentCard);
          if (this.state.currentCard === 2) {
            currentMovie = this.props.nextMovieInfo
          } else if (this.state.currentCard === 1) {
            currentMovie = this.props.movieInfo
          } else if (this.state.currentCard === 0) {
            currentMovie = this.props.preMovieInfo
          }
          this.updatedMovieCard(
            currentMovie,
            this.props.currentMovieList.indexOf(currentMovie),
            "right");
        }
        , 200);
    }
  }
  render() {
    //  console.log("currentCard=", this.state.currentCard);
    return (
      <div id="movie-results-item" className="movie-widgets">
        <div
          className="search-back"
          data-target="movie-genre-item"
          onClick={this.backButton}
          style={{ color: "#ffffff" }}>
          <i className="fa fa-chevron-left" style={{ color: "inherit" }}></i>
          Back
        </div>
        <div class="card-carousel">

          <MovieCard
            id={this.state.firstID}
            classes={"movie-item-box prev"}
            movieInfo={this.props.preMovieInfo}
            languageList={this.props.languageList}
            categories={this.props.categories}
            guestInRoom={this.props.guestInRoom} />

          <MovieCard
            id={this.state.thirdID}
            classes={"movie-item-box next"}
            movieInfo={this.props.nextMovieInfo}
            languageList={this.props.languageList}
            categories={this.props.categories}
            guestInRoom={this.props.guestInRoom} />

          <MovieCard
            id={this.state.secondID}
            classes={"movie-item-box active"}
            movieInfo={this.props.movieInfo}
            languageList={this.props.languageList}
            categories={this.props.categories}
            guestInRoom={this.props.guestInRoom} />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    movieList: state.store.vod.VODData ?
      state.store.vod.VODData.channelList : null,
    movieInfo: state.store.vod.currentMovie,
    preMovieInfo: state.store.vod.previousMovie,
    nextMovieInfo: state.store.vod.nextMovie,
    languageList: state.store.vod.VODData ?
      state.store.vod.VODData.channelLanguageOrder : null,
    categories: state.store.vod.VODData ?
      state.store.vod.VODData.channelCategoryOrder : null,
    guestInRoom: state.store.guestInRoom,
    currentMovieList: state.store.vod.movieList,
    menuColor: state.store.home.MenuColor
  }
}

export default connect(
  mapStateToProps, {
  setCurrentMovie,
  setVideoPlayer,
  popupOpenClose,
  setPreviousMovie,
  nextMovie
}
)(moiveInfo);